import { Year } from "@/util/chartUtils";
import { GrowthChartData } from "./hooks/useCommunityGrowthSeries";
import { ChartConfig } from "@/components/ui/Chart";

const lineColors = [
  "var(--color-chart-1-alternative)", // cohortYear + 1
  "var(--color-chart-5)", // cohortYear
  "var(--color-chart-1)", // cohortYear - 1
  "var(--color-chart-2)", // cohortYear - 2
  "var(--color-chart-3)", // cohortYear - 3
  "var(--color-chart-4)", // cohortYear - 4
];

export const buildConfig = (data: GrowthChartData | undefined) =>
  data
    ? Object.keys(data)
        .sort((a, b) => +b - +a)
        .reduce((acc, cur, idx) => {
          acc[cur] = {
            color: lineColors[idx % lineColors.length],
            hide: data[cur as Year]?.length === 0,
          };
          return acc;
        }, {} as ChartConfig)
    : {};
